export default __webpack_public_path__ + "static/media/ae-lt.d4149f16.png";